import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/automated-calling",
    name: "AutomatedCalling",
    component: () => import("./automatedCalling.vue"),
  },
  {
    path: "/call-recording-search",
    name: "Call Recording Search",
    component: () => import("./callRecordingSearch.vue"),
  },
  {
    path: "/customer-lead-lists",
    name: "Customer Lead Lists",
    component: () => import("./customerLeadListManager.vue"),
  },
  {
    path: "/customer-devices",
    name: "Customer Mobile Devices",
    component: () => import("./customerDevices.vue"),
  },
] satisfies RouteRecordRaw[];
